import { PRODUCT_ENTITLEMENTS } from '@headline/schemas'
import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { ApiReferencePage } from '@/components/api-reference/ApiReferencePage'
import { accountQuery } from '@/lib/queries'
import { workspaceApiReferenceQuery } from '@/lib/workspace-api-queries'

/**
 * A client workspace's API reference (CLI-1050): the API & MCP page's reference, behind the same gate on
 * the server. A disabled product redirects to the client's Home, as the API page does (UX only). The
 * reference read is started, not awaited: clipbook-api may be slow, and the page shows its own state.
 */
export const Route = createFileRoute(
  '/app/accounts/$accountId_/subaccounts/$subaccountId/api_/reference',
)({
  loader: async ({ context, params }) => {
    const account = await context.queryClient.ensureQueryData(accountQuery(params.accountId))
    if (!account.entitlements.includes(PRODUCT_ENTITLEMENTS.api)) {
      throw redirect({
        to: '/app/accounts/$accountId/subaccounts/$subaccountId',
        params: { accountId: params.accountId, subaccountId: params.subaccountId },
      })
    }
    void context.queryClient.prefetchQuery(workspaceApiReferenceQuery(params.subaccountId))
  },
  component: ClientApiReference,
})

function ClientApiReference() {
  const { accountId, subaccountId } = Route.useParams()
  return (
    <ApiReferencePage
      subaccountId={subaccountId}
      back={
        <Link
          to="/app/accounts/$accountId/subaccounts/$subaccountId/api"
          params={{ accountId, subaccountId }}
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="size-4" /> API & MCP
        </Link>
      }
    />
  )
}
